import { React, useState, } from 'react';

// Photo component — real Pexels stock images, with monochrome treatment.
// Falls back to a striped placeholder if loading fails.

const PhotoPlaceholder = ({
	caption = "photograph",
	ratio = "3/4",
	tone = "auto",
	index = 0,
	showMeta = false,
	className = "",
	style = {},
	imgStyle = {},
	src = "",
}) => {
	
	// Vary the requested width across slots so adjacent cells don't show identical crops
	// const w = 800 + ((index * 137) % 7) * 80;
	
	// Subtle deterministic crop variation via object-position
	// const xs = [50, 30, 70, 40, 60, 35, 55, 65];
	// const ys = [50, 40, 60, 45, 55, 35, 65, 50];
	// const ox = xs[index % xs.length];
	// const oy = ys[(index + 3) % ys.length];
	
	const isDark = tone === "dark";
	const bg = isDark ? "#16161a" : "#ece8e1";
	const fg = isDark ? "#cfcbc2" : "#3a362f";
	
	const [loaded, setLoaded] = useState(false);
	const [err, setErr] = useState(false);
	

	
	return (
		<div
			className={`photo-placeholder ${className}`}
			style={{
				position: "relative",
				aspectRatio: ratio,
				width: "100%",
				background: bg,
				overflow: "hidden",
				...style,
			}}
		>

			{!err && (
				<img
					src={src}
					alt={caption}
					loading="lazy"
					decoding="async"
					onLoad={() => setLoaded(true)}
					onError={() => setErr(true)}
					style={{
						position: "absolute",
						inset: 0,
						width: "100%",
						height: "100%",
						objectFit: "contain",
						// objectPosition: `${ox}% ${oy}%`,
						// Monochrome editorial treatment: desaturate + lift midtones slightly
						filter: "grayscale(1) contrast(1.04) brightness(1.02)",
						opacity: loaded ? 1 : 0,
						transition: "opacity 700ms ease",
						...imgStyle
					}}
				/>
			)}
		
			{/* Loading striped fallback (also shown if the image errors out) */}
			{(!loaded || err) && (
				<svg
					width="100%"
					height="100%"
					style={{ position: "absolute", inset: 0, display: "block", opacity: 1 }}
					preserveAspectRatio="none"
					aria-hidden
				>
					<defs>
						<pattern
							id={`stripes-${index}`}
							width="8"
							height="8"
							patternUnits="userSpaceOnUse"
							patternTransform={(isNaN(index) === false) ? `rotate(${-22 + (index % 3) * 11})` : 'rotate(0)'}
						>
							<rect width="8" height="8" fill={bg} />
							<rect width="4" height="8" fill={isDark ? "#1d1d22" : "#e3ddd2"} />
						</pattern>
					</defs>
					<rect width="100%" height="100%" fill={`url(#stripes-${index})`} />
				</svg>
			)}
			
			{showMeta && (
				<div
					style={{
						position: "absolute",
						inset: 0,
						display: "flex",
						alignItems: "flex-end",
						justifyContent: "space-between",
						padding: "14px 16px",
						fontFamily: "'JetBrains Mono', ui-monospace, monospace",
						fontSize: 10,
						letterSpacing: "0.08em",
						textTransform: "uppercase",
						color: fg,
						textShadow: isDark ? "0 1px 8px rgba(0,0,0,0.6)" : "0 1px 8px rgba(255,255,255,0.45)",
						pointerEvents: "none",
					}}
				>
					<span style={{ opacity: 0.85 }}>↳ {caption}</span>
					<span style={{ opacity: 0.7 }}>{String(index + 1).padStart(3, "0")}</span>
				</div>
			)}

		</div>
	);
};

export default PhotoPlaceholder;
